var exports = {
  "L": "clickableLabel__oWcao2",
};

module.exports = exports;
